import request from '../../../api/api';
import {ACT_ACTION, SEND_ACT_EMAIL} from './types';

function getDateString(date) {
    const dt = (('0' + date.getDate()).slice(-2));
    const month = (('0' + (date.getMonth() + 1)).slice(-2));

    return dt + '.' + month + '.' + date.getFullYear();
}

export default function (act, current) {
    return dispatch => {
        return request('/v1/fin/get_act/mail?object_type=' + current.type + '&object_id=' + current.id +
            '&sales_direction_id=' + act.currentDirection + '&date_begin=' + getDateString(act.begin) +
            '&date_end=' + getDateString(act.end) + '&email=' + act.email
        ).then(
            data => {
                dispatch({
                    type: SEND_ACT_EMAIL,
                    payload: data.data,
                });
            },
            error => {
                if (error.data && error.data.returnCode === 0) {
                    dispatch({
                        type: SEND_ACT_EMAIL,
                        payload: {
                            emailError: error.data.error
                        },
                    });

                    return null;
                } else return Promise.reject(error);
            }
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/finance/actions/SendEmail.js
 **/